import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@ipreo/northstar';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable()
export class FollowsService {
  private readonly apiHost: string;

  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.apiHost = config.params.apiHost as string;
  }

  public getFollows(): Observable<string[]> {
    const url = `${this.apiHost}/v1/deals/fixed-income/municipal/follow`;

    return this.http
      .get(url, {
        observe: 'response',
      })
      .pipe(
        mergeMap((response: HttpResponse<any[]>) => {
          const data = response.status === 200 && response.body;

          return data ? of(data) : throwError(Error('Cannot load follows'));
        })
      );
  }

  public follow(dealId: string): Observable<string[]> {
    const url = `${this.apiHost}/v1/deals/fixed-income/municipal/${dealId}/follow`;

    return this.http
      .post(url, null, {
        observe: 'response',
      })
      .pipe(
        mergeMap((response: HttpResponse<any[]>) => {
          const data = response.status === 200 && response.body;

          return data ? of(data) : throwError(Error('Cannot follow deal'));
        })
      );
  }

  public unfollow(dealId: string): Observable<string[]> {
    const url = `${this.apiHost}/v1/deals/fixed-income/municipal/${dealId}/follow`;

    return this.http
      .delete(url, {
        observe: 'response',
      })
      .pipe(
        mergeMap((response: HttpResponse<any[]>) => {
          const data = response.status === 200 && response.body;

          return data ? of(data) : throwError(Error('Cannot unfollow deal'));
        })
      );
  }

  public followMultiple(dealIds: string[]): Observable<string[]> {
    const url = `${this.apiHost}/v1/deals/fixed-income/municipal/follow`;

    return this.http
      .post(url, dealIds, {
        observe: 'response',
      })
      .pipe(
        mergeMap((response: HttpResponse<any[]>) => {
          const data = response.status === 200 && response.body;

          return data ? of(data) : throwError(Error('Cannot follow deals'));
        })
      );
  }

  public unfollowMultiple(dealIds: string[]): Observable<string[]> {
    const url = `${this.apiHost}/v1/deals/fixed-income/municipal/unfollow`;

    return this.http
      .post(url, dealIds, {
        observe: 'response',
      })
      .pipe(
        mergeMap((response: HttpResponse<any[]>) => {
          const data = response.status === 200 && response.body;

          return data ? of(data) : throwError(Error('Cannot unfollow deals'));
        })
      );
  }

  public getGroupFollows(): Observable<string[]> {
    const url = `${this.apiHost}/v1/deals/fixed-income/municipal/groupfollow`;

    return this.http
      .get(url, {
        observe: 'response',
      })
      .pipe(
        mergeMap((response: HttpResponse<any[]>) => {
          const data = response.status === 200 && response.body;

          return data ? of(data) : throwError(Error('Cannot load follows'));
        })
      );
  }

  public groupFollow(dealId: string): Observable<string[]> {
    const url = `${this.apiHost}/v1/deals/fixed-income/municipal/${dealId}/groupfollow`;

    return this.http
      .post(url, null, {
        observe: 'response',
      })
      .pipe(
        mergeMap((response: HttpResponse<any[]>) => {
          const data = response.status === 200 && response.body;

          return data ? of(data) : throwError(Error('Cannot follow deal'));
        })
      );
  }

  public groupUnfollow(dealId: string): Observable<string[]> {
    const url = `${this.apiHost}/v1/deals/fixed-income/municipal/${dealId}/groupfollow`;

    return this.http
      .delete(url, {
        observe: 'response',
      })
      .pipe(
        mergeMap((response: HttpResponse<any[]>) => {
          const data = response.status === 200 && response.body;

          return data ? of(data) : throwError(Error('Cannot unfollow deal'));
        })
      );
  }
}
